export enum TOKEN {
  Config = 'Config',
  Engine = 'Engine',
  System = 'System',
  Media = 'Media',
  Network = 'Network',
  MediaEventHandler = 'MediaEventHandler',
  ChannelEventHandler = 'ChannelEventHandler',
  ChannelAudioObserverEventHandler = 'ChannelAudioObserverEventHandler',
  ChannelAudioObserverMissingProducerRestorer = 'ChannelAudioObserverMissingProducerRestorer',
  ChannelStateSynchronizer = 'ChannelStateSynchronizer',
  ChannelStateSyncEventHandler = 'ChannelStateSyncEventHandler',
  CompositeStatsParser = 'CompositeStatsParser',
  PeriodicStatsReporter = 'PeriodicStatsReporter',
  WIDIgnoreSsrcList = 'WIDIgnoreSsrcList',
  WebRTCIssueDetector = 'WebRTCIssueDetector',
  WIDStatsAdapter = 'WIDStatsAdapter',
  ScoresCalculator = 'ScoresCalculator',
  LoggerFactory = 'LoggerFactory',
  MediaStreamTrackManager = 'MediaStreamTrackManager',
  EventsQueue = 'EventsQueue',
  ClientEventEmitter = 'ClientEventEmitter',
  Peers = 'Peers',
  CallState = 'CallState',
  RemotePeerTracks = 'RemotePeerTracks',
  MyPeer = 'MyPeer',
  InternalEventEmitter = 'InternalEventEmitter',
  PeerTrackFactory = 'PeerTrackFactory',
  PeerFactory = 'PeerFactory',
  PeerConsumerFactory = 'PeerConsumerFactory',
  AudioTrackFactory = 'AudioTrackFactory',
  VideoTrackFactory = 'VideoTrackFactory',
  AudioTrackProcessorFactory = 'AudioTrackProcessorFactory',
  IntegrationsService = 'IntegrationsService',
  ProcessorsCache = 'ProcessorsCache',
  StatsHandler = 'StatsHandler',
  DataChannelsManager = 'DataChannelsManager',
  WIDHandler = 'WIDHandler',
  AnalyticsApiClient = 'AnalyticsApiClient',
  TransportsStatsProvider = 'TransportsStatsProvider',
  LocalMutex = 'LocalMutex',
  PeersStorage = 'PeersStorage',
  SignalingApiClient = 'SignalingApiClient',
  DatachannelHeartbeater = 'DatachannelHeartbeater',
  SignalingHeartbeater = 'SignalingHeartbeater',
  PendingClosureProducerStorage = 'PendingClosureProducerStorage',
  ProducerCloseManager = 'ProducerCloseManager',
  NetworkTransportPolicyManager = 'NetworkTransportPolicyManager',
  ClientMetaProvider = 'ClientMetaProvider',
}
